import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import { useAppDispatch } from "../../hooks/hooks";
import { key_ScholarshipProviders } from "../../utils/constants";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { ScholarshipProviderType } from "../../types/ScholarshipProviderType";
import { useGetScholarshipProvidersQuery } from "../../hooks/useQueryScholarshipProviders";
import { updateScholarshipProvider } from "../../services/school/scholarshipProvider";
import { setScholarshipProviderData } from "../../redux/slices/school/scholarshipProvider";

const columnNamesMap: { [key: string]: string } = {
    description: "Nome",
    code: "Código",
    internalCode: "Código Interno",
};

export const ScholarshipProviders = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemToBeDeleted, setItemToBeDeleted] = useState<ScholarshipProviderType | null>(null);

    const queryClient = useQueryClient();
    const dispatch = useAppDispatch();
    const { data, status } = useGetScholarshipProvidersQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationUpdate = useMutation(updateScholarshipProvider, {
        onSuccess: () => {
            queryClient.invalidateQueries(key_ScholarshipProviders);
            toast.success("Provedor de Bolsa removido!");
        },
        onError: () => {
            toast.error("Erro ao apagar Provedor de Bolsa.");
        }
    });

    const handleCreate = () => {
        navigate(routes.createScholarshipProvider);
    };

    const handleEdit = (k: ScholarshipProviderType) => {
        dispatch(setScholarshipProviderData(k));
        navigate(routes.updateScholarshipProvider);
    };

    const handleDelete = (k: ScholarshipProviderType) => {
        k.status = false;
        mutationUpdate.mutateAsync(k);
    };

    const openDeleteDialog = (s: ScholarshipProviderType) => {
        setItemToBeDeleted(s);
    };

    const confirmDelete = () => {
        if (itemToBeDeleted) {
            handleDelete(itemToBeDeleted);
        }
    };

    const options = data?.items.map((item) => [
        {
            label: "Editar",
            onClick: () => handleEdit(item),
            icon: <Pencil1Icon />
        },
        {
            label: "Eliminar",
            onClick: () => openDeleteDialog(item),
            icon: <TrashIcon />
        },
    ]) || [];

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    return (
        <>
            <Lists
                status={status}
                TableComponent={() => (
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                )}
                handleClickCreate={handleCreate}
            />
            <ConfirmAlertDialog
                open={!!itemToBeDeleted}
                onOpenChange={(open) => !open && setItemToBeDeleted(null)}
                title="Esta operação é irreversível"
                item={itemToBeDeleted}
                onConfirm={confirmDelete}
                onCancel={() => setItemToBeDeleted(null)}
            />
        </>
    );
};
